export const deriveIdFromCanvasObject = (canvasObject) =>
  `${canvasObject.left}${canvasObject.top}${canvasObject.height}${canvasObject.width}`;
